import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaFontWeight, YodaJustifyContent } from 'yoda-ui/yodaTheme';

export const TacticPaginationWrapperStyle: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  justifyContent: YodaJustifyContent.spaceBetween,
  alignItems: YodaJustifyContent.center,
};

export const TacticPaginationStyle: SxProps<Theme> = {
  width: '68px',
};

export const TacticSelectStyle: SxProps<Theme> = {
  height: '48px',
  fontSize: YodaFontSize.small,
  color: YodaColors.textSecondary,
  borderRadius: '8px',
  backgroundColor: YodaColors.white,

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: YodaColors.textSecondary,
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: YodaColors.textSecondary,
  },
};

export const TacticPaginationResultStyle: SxProps<Theme> = {
  color: YodaColors.gray4,
};

export const TacticPaginationCountStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: YodaJustifyContent.flexEnd,

  '& .MuiPagination-ul li:not(:first-of-type):not(:last-of-type) button': {
    color: YodaColors.textSecondary,

    '&:hover': {
      backgroundColor: 'transparent',
      color: YodaColors.blue8,
    },

    '&.Mui-selected': {
      color: YodaColors.blue7,
      fontWeight: YodaFontWeight.bold,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: 'none',
      outline: 'none',
    },

    '&.Mui-selected:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
};
